import { connect } from 'react-redux';
import { compose, applySpec } from 'ramda';
import { withTranslation } from 'react-i18next';
import CardiovascularInvestigations from 'components/CardiovascularInvestigations';
import { requestGetListCardiovascularInvestigations } from 'store/actionCreators/patient';
import { getUserId, getUserRole } from 'store/selectors/user';
import { getPatientPageUrlId } from 'store/selectors/router';
import { getCardiovascularInvestigations } from 'store/selectors/patient';
import { downloadDocumentReferencePdf } from 'store/actionCreators/reports/singleItems';

const mapStateToProps = applySpec({
  userId: getUserId,
  patientId: getPatientPageUrlId,
  data: getCardiovascularInvestigations,
  role: getUserRole,
});

const mapDispatchToProps = {
  loadData: requestGetListCardiovascularInvestigations,
  downloadDocumentReferencePdf,
};

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(CardiovascularInvestigations);
